import { Component, Input, OnInit } from '@angular/core';

export enum PrSumType {
  POSITIF = 'POSITIF',
  NEGATIF = 'NEGATIF',
  NEUTRAL = 'NEUTRAL',
  NEGATIF_UNSIGNED = 'NEGATIF_UNSIGNED',
  SEP = 'SEP',
  TOTAL = 'TOTAL',
  TOTALNEG = 'TOTALNEG',
  BLANK = 'BLANK',
}

@Component({
    selector: 'pr-sum-item',
    templateUrl: './pr-sum-item.component.html',
    styleUrls: ['./pr-sum-item.component.scss'],
    standalone: false
})
export class PrSumItemComponent implements OnInit {
  @Input() type: PrSumType;
  @Input() label: string;
  @Input() value: any;

  constructor() {}

  ngOnInit() {}

  showSign(val, sign) {
    return parseInt(val.replace(/\D/g, '')) == 0 ? '' : sign;
  }
}
